module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', {
    staticClass: "primary ma-1 mt-2"
  }, [_c('v-card-title', {
    staticClass: "text-xs-center"
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs12": ""
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.repos.length) + " Proyectos")])])], 1)], 1), _vm._v(" "), _vm._l((_vm.repos), function(repo) {
    return _c('v-layout', {
      key: repo.id,
      staticClass: "ma-1 mb-2",
      attrs: {
        "xs10": "",
        "offset-xs1": "",
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', [_c('v-toolbar', {
      attrs: {
        "card": "",
        "color": "white"
      }
    }, [_c('v-toolbar-title', {
      staticClass: "body-2 grey--text"
    }, [_vm._v(_vm._s(repo.name))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('i', {
      staticClass: "fa fa-star"
    }), _vm._v(" " + _vm._s(repo.stargazers_count) + "\n          "), _c('i', {
      staticClass: "fa fa-code-fork"
    }), _vm._v(" " + _vm._s(repo.forks) + "\n          "), _c('i', {
      staticClass: "fa fa-bug"
    }), _vm._v(" " + _vm._s(repo.open_issues_count) + "\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "to": ("portfolio/" + (repo.name)),
        "target": "__blank",
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("content_paste")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "href": repo.html_url,
        "target": "__blank",
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("send")])], 1)], 1)], 1)], 1)], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-212d976b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Portfolio.vue
// module id = 262
// module chunks = 1